import { StatusSelectDropdown } from "@/domain/status/components/status-select-dropdown";
import { useGetStatusListForWorkspace } from "@/domain/status/hooks/api/use-get-status-list-for-workspace";

import { SelectFieldProps } from "./select-field-props";
import { SingletonSelectField } from "./singleton-select-field";

export function StatusSelectField({ workspaceId, value, onChange, disabled }: SelectFieldProps) {
  const { statusList } = useGetStatusListForWorkspace({ workspaceId });

  return (
    <SingletonSelectField
      value={value}
      disabled={disabled}
      optionList={statusList}
      renderDropdown={({ value: dropdownValue, disabled: dropdownDisabled, children }) => (
        <StatusSelectDropdown
          workspaceId={workspaceId}
          selected={dropdownValue ? { statusId: dropdownValue } : undefined}
          onSelect={(status) => onChange(status ? status.id : "")}
          isReadOnly={dropdownDisabled}
          asChild
        >
          {children}
        </StatusSelectDropdown>
      )}
    />
  );
}
